import React, { useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import styles from "./onlinetv_popular.module.scss";
import VideoBoxGrid from "../components/video_box_grid";
import VideoBoxThumb from "../components/video_box_thumb";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const OnlinetvPopular = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <section className={styles.section_popular}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.cat_container}>
            <div className={styles.cat_title}>Top Category</div>
            <div className={styles.top_cat_wrapper}>
              {new Array(8).fill(1).map((course, i) => (
                <VideoBoxThumb key={i} />
              ))}
            </div>
          </div>
          <div className={styles.tab_container}>
            <div className="blog_top_story_tab">
              <Tabs value={value} onChange={handleChange}>
                <Tab label="All" {...a11yProps(0)} />
                <Tab label="Study Abroad" {...a11yProps(1)} />
                <Tab label="Top University" {...a11yProps(2)} />
                <Tab label="Q&S" {...a11yProps(3)} />
              </Tabs>

              <TabPanel value={value} index={0}>
                <div className={styles.blog_thumb_box_wrapper}>
                  {new Array(4).fill(1).map((course, i) => (
                    <VideoBoxGrid key={i} metaBottom />
                  ))}
                </div>
              </TabPanel>

              <TabPanel value={value} index={1}>
                <div className={styles.blog_thumb_box_wrapper}>
                  {new Array(4).fill(1).map((course, i) => (
                    <VideoBoxGrid key={i} metaBottom />
                  ))}
                </div>
              </TabPanel>
              <TabPanel value={value} index={2}>
                <div className={styles.blog_thumb_box_wrapper}>
                  {new Array(4).fill(1).map((course, i) => (
                    <VideoBoxGrid key={i} metaBottom />
                  ))}
                </div>
              </TabPanel>
              <TabPanel value={value} index={3}>
                <div className={styles.blog_thumb_box_wrapper}>
                  {new Array(4).fill(1).map((course, i) => (
                    <VideoBoxGrid key={i} metaBottom />
                  ))}
                </div>
              </TabPanel>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OnlinetvPopular;
